import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ServiceWorkerClientCommunicationService {
    communicationChannel = new BroadcastChannel('service-worker');
    installTimer: Date = new Date();

    constructor() {
        this.communicationChannel.onmessage = async (event) => {
            await this.handleServiceWorkerMessage(event);
        };
    }

    public sendMessage(msg: { type: string }) {
        this.communicationChannel.postMessage(msg);
    }

    private async handleServiceWorkerMessage(event: MessageEvent<any>) {
        switch (event.data.type) {
            case 'error':
                console.log(event.data.error);
                this.communicationChannel.postMessage({type: 'install-error'});
                break;
            case 'install-success':
                console.info('new service worker has been installed with manifest version ' + event.data.timestamp);
                console.info('Installation took ' + (new Date().getTime() - this.installTimer.getTime()) / 1000 + 'seconds');
                this.communicationChannel.postMessage({type: 'install-success-response'});
                break;
            case 'install-start':
                this.installTimer = new Date();
                console.info('installing new service worker');
                break;
            default:
                console.error('unhandled Service worker message: ' + event?.data?.type, event);
        }
    }
}